import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Tooltip } from "antd";
import Layout from "../../components/global/layout";
import shared from "./shared";
import methodModel from "../../methods/methods";
import { CgArrowLeft } from "react-icons/cg";
import { LiaEdit } from "react-icons/lia";
import { useSelector } from "react-redux";
import environment from "../../environment";
import { useQuery, useMutation } from "@tanstack/react-query";
import loader from "../../methods/loader";
import ApiClient from "../../methods/api/apiClient";
import { FaChevronLeft, FaEdit } from "react-icons/fa";
import { RiFileList3Line } from "react-icons/ri";

function ViewUsers() {
  const user = useSelector((state) => state.user);
  const history = useNavigate();
  const { id } = useParams();

  const [CardSent, setCardSent] = useState(false);
  const [data, setData] = useState({}); 
  const GetUserDetails = () => {
    loader(true);
    ApiClient.get(shared.detailApi, { id }).then(res => {
      if (res.success) {
        setData(res?.data);
      }
      loader(false)
    })
  }

  useEffect(() => {
    GetUserDetails()
  }, [])
  /** SEND CARD */
  const sendCard = async () => {
    const params = new URLSearchParams({
      id: data?._id || data?.id,
    });

    const res = await fetch(`${shared?.cardSend}?${params}`, {
      headers: {
        authorization: user?.app_token,
      },
    });

    return res.json();
  };

  const cardMutation = useMutation({
    mutationFn: sendCard,
    onSuccess: () => {
      setCardSent(true);
    },
  });

  const CardSendHandler = () => {
    cardMutation.mutate();
  };

  /** OPEN IMAGE */
  const openImage = (image) => {
    if (image) window.open(methodModel.noImg(image), "_blank");
  };


  return (
    <Layout>
      <div className="wrapper_section">

        <div className='flex gap-3 justify-between flex-wrap mb-8'>
          <div className="flex gap-3">
            <Tooltip placement="top" title="Back">
              <Link
                onClick={() => history(-1)}
                className="min-w-[30px] w-[30px] h-[30px] rounded-full bg-[#CC9900] text-white flex items-center justify-center hover:opacity-80"
              >
                <FaChevronLeft />
              </Link>
            </Tooltip>
            <div className=''>
              <h3 className="text-lg lg:text-2xl font-semibold text-[#221E10]">
                {shared.addTitle} Details
              </h3>
              <p className='text-sm text-[#2D2D2D]'></p>
            </div>
          </div>

          <div className="flex items-center gap-2">

            {methodModel.hasPermission(user, shared.permissionKey, "edit") && (
              <Tooltip placement="top" title="Edit">
                <Link
                  to={`/${shared.url}/edit/${id}`}
                  className=" flex items-center gap-1 hover:opacity-80 ml-auto"
                >
                  <span className='cursor-pointer rounded-full w-8 h-8 flex items-center justify-center text-lg hover:opacity-80 bg-[#F2F2F2] text-[#797979]'><FaEdit className='' /></span>
                  <p>Edit</p>
                </Link>
              </Tooltip>
            )}
          </div>
        </div>

        {/* BASIC INFO */}
        <div className="grid grid-cols-1 gap-6">
          <div className="bg-white p-5 rounded-[12px] shadow-[0px_3px_14px_-8px_#888888] border">
            <div className='mb-5'>
              <div className='flex gap-2'>
                <RiFileList3Line className="text-[#CC9900] text-xl relative top-[1px]" />
                <h4 className='text-[#2D2D2D] font-semibold'>Basic Information </h4>
              </div>
              <p className='text-sm text-[#717182]'></p>
            </div>

            <div className="grid grid-cols-12 gap-5">
              <div className="col-span-12 sm:col-span-6">
                <label className="text-[14px] text-[#0000009c] tracking-wider mb-1">
                  First Name:
                </label>
                <p className="relative bg-[#F7F7F7] text-[#7B7B7B] w-full rounded-lg min-h-10 flex items-center focus:outline focus:outline-[1px] focus:outline-[#e5e7eb] focus:ring-0 py-2 px-3 capitalize">
                  {data?.fullName?.split(" ")[0]}
                </p>
              </div>

              <div className="col-span-12 sm:col-span-6">
                <label className="text-[14px] text-[#0000009c] tracking-wider mb-1">
                  Last Name:
                </label>
                <p className="relative bg-[#F7F7F7] text-[#7B7B7B] w-full rounded-lg min-h-10 flex items-center focus:outline focus:outline-[1px] focus:outline-[#e5e7eb] focus:ring-0 py-2 px-3 capitalize">
                  {data?.fullName?.split(" ")[1]}
                </p>
              </div>

              <div className="col-span-12 sm:col-span-6">
                <label>Email:</label>
                <p className="relative bg-[#F7F7F7] text-[#7B7B7B] w-full rounded-lg min-h-10 flex items-center focus:outline focus:outline-[1px] focus:outline-[#e5e7eb] focus:ring-0 py-2 px-3 break-all">
                  {data?.email}
                </p>
              </div>
              <div className="col-span-12 sm:col-span-6">
                <label>Mobile No:</label>
                <p className="relative bg-[#F7F7F7] text-[#7B7B7B] w-full rounded-lg min-h-10 flex items-center focus:outline focus:outline-[1px] focus:outline-[#e5e7eb] focus:ring-0 py-2 px-3">
                 +{data?.dialCode} {data?.mobileNo}
                </p>
              </div>
              {data?.image && (
                <div className="col-span-12 sm:col-span-6">
                  <label>Image:</label>
                  <img
                    src={methodModel.noImg(data?.image)}
                    className="w-[100px] h-[100px] rounded-lg cursor-pointer"
                    onClick={() => openImage(data?.image)}
                  />
                </div>
              )}

            </div>
          </div>
        </div>

      </div>
    </Layout>
  );
}

export default ViewUsers;